/* eslint-disable no-nested-ternary */
import { isNil } from '@seedcloud/ramda-extra'
import { useState, useEffect } from 'react'

import { ReactComponent as Asc } from 'assets/feathers/arrow-up.svg'
import { ReactComponent as Sort } from 'assets/feathers/pointing.svg'
import { ReactComponent as Desc } from 'assets/feathers/sort-down.svg'
import { styled, apply } from 'lib/styled'

const Container = styled.span(apply('ml-2'), ({ id }) =>
  id === 'status' ? apply('mr-a') : {}
)

export function SortIcon({ column, onSort, sortBy }) {
  const [isSorted, setIsSorted] = useState(false)
  const [isSortedAsc, setIsSortedAsc] = useState(false)
  useEffect(() => {
    if (sortBy !== column.id) {
      setIsSorted(false)
      setIsSortedAsc(false)
    }
  }, [sortBy])

  function handleSort() {
    if (isNil(onSort)) {
      return
    }
    if (!isSorted) {
      setIsSorted(true)
      setIsSortedAsc(true)
      onSort(column.id, 'asc')
    } else if (isSortedAsc) {
      setIsSortedAsc(false)
      onSort(column.id, 'desc')
    } else {
      setIsSorted(false)
      onSort('', '')
    }
  }

  return (
    <Container id={column.id} onClick={handleSort}>
      {isSorted ? (
        isSortedAsc ? (
          <Asc width={10} height={14} fill="#969696" />
        ) : (
          <Desc width={10} height={14} fill="#969696" />
        )
      ) : (
        <Sort width={14} height={13} fill="#969696" />
      )}
    </Container>
  )
}
